import styled from 'styled-components';
import {tokens} from '@tickchak/react-share/app';
import {
    dFlex, dFlexColumn, flexWrap, flexRowReverse,
    alignCenter, alignEnd, justifyCenter, justifyEnd
} from '../../../../../../../globalVariables/GlobalFlex';

export {dot} from '../../timetableSales.css';

export const figures = styled.div`
  ${dFlex}
  ${flexWrap}
  ${alignCenter}
  ${justifyEnd}
  align-self: stretch;
  gap: var(--space-md);
`;
export const figure = styled.div`
  ${dFlexColumn}
  ${alignEnd}
  ${justifyCenter}
  flex: 1 1 0;
`;
export const figureDivider = styled.div`
  width: 1px;
  height: 19px;
  align-self: center;
  background: var(--TA-color-border-subtle);
`;
export const figureVal = styled.div`
  font-size: ${tokens.typography.fontSize.body};
  font-weight: ${tokens.typography.fontWeight.regular};
  line-height: 20px;
  white-space: nowrap;
`;
export const figureLabel = styled.div`
  ${dFlex}
  ${flexRowReverse}
  ${alignCenter}
  gap: var(--space-sm);
  font-size: ${tokens.typography.fontSize.bodySmall};
  line-height: 20.5px;
  white-space: nowrap;
`;
